import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { mapProps } from 'recompose';

import withModal from '../../../../../../../../../../../components/global/modal/withModal';
import PrintProductSizes from './PrintProductSizes';
import DismissButton from '../../../../../../../../../../../components/global/DismissButton';
import Angle from '../../../../../../../../../../../components/global/Angle';
import PurchasingOptionsPhotoPreview from '../../../PurchasingOptionsPhotoPreview';

export const PRINT_PRODUCT_SIZES_MODAL = 'PRINT_PRODUCT_SIZES_MODAL';

const propTypes = {
  className: PropTypes.string,
  printProduct: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  printProductId: PropTypes.string,
  onPrintProductSizeSelect: PropTypes.func.isRequired,
};

const PrintProductSizesModalComponent = ({
  className,
  printProduct,
  printProductId,
  onClose,
  photo,
  ...props
}) => {
  const classes = classNames({
    [className]: !!className,
    'modal-contained-wrap': true,
  });

  return (
    <div className={classes}>
      <div className="purchasing-options-list-header modal-contained-header">
        <button className="btn-reset d-md-none" onClick={onClose}>
          <Angle direction="left" />
        </button>
        <span className="modal-contained-title">Select a size</span>
        <DismissButton
          className="ml-auto d-none d-md-block"
          onClick={onClose}
        />
      </div>

      {photo && <PurchasingOptionsPhotoPreview photo={photo} />}

      <div className="modal-contained-content">
        <div className="purchasing-options-list-contents">
          {/* If a printProduct is directly passed do not pass the id */}
          <PrintProductSizes
            printProductId={printProduct ? undefined : printProductId}
            printProduct={printProduct}
            {...props}
          />
        </div>
      </div>
    </div>
  );
};

PrintProductSizesModalComponent.propTypes = propTypes;

const PrintProductSizesModal = withModal(
  mapProps(({ onClose, onRequestClose, actionProps = {}, ...props }) => ({
    onClose: onClose || onRequestClose,
    ...actionProps,
    ...props,
  }))(PrintProductSizesModalComponent),
  {
    name: PRINT_PRODUCT_SIZES_MODAL,
    size: 'sm',
    type: 'full',
    hideHeader: true,
    dismissible: false,
    shouldCloseOnOverlayClick: false,
    className: 'print-product-sizes-modal modal-contained',
  },
);

export default PrintProductSizesModal;
